// removed by extract-text-webpack-plugin
module.exports = {"component":"_26MyXf_wuTfXyM7V3MCNTT","selectGroup":"_2RQmM_SBKbilE2kgBMbxYR"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AddressChosenComponent/AddressChosenComponent.scss
 ** module id = 394
 ** module chunks = 0
 **/